import { Component, OnInit } from '@angular/core';
import { DialogService } from '@app/modules/core/services/dialog.service';

@Component({
  selector: 'iq-system-error-page',
  templateUrl: './system-error.page.html',
  styleUrls: ['./system-error.page.scss']
})
export class SystemErrorPage implements OnInit {

  constructor( private dialogService: DialogService) { }

  ngOnInit() {
    this.dialogService.closeLoadingDialog();
  }
}
